import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-7ebd699f"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "swiper-activity-slide-container"
};
var _hoisted_2 = {
  class: "content-box"
};
var _hoisted_3 = {
  class: "content-left"
};
var _hoisted_4 = {
  class: "status-tag"
};
var _hoisted_5 = {
  class: "content-right"
};
var _hoisted_6 = {
  class: "contest-title"
};
var _hoisted_7 = {
  class: "tag-box"
};
var _hoisted_8 = ["title"];
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "主办单位：", -1);
});
var _hoisted_10 = ["title"];
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "承办单位：", -1);
});
var _hoisted_12 = ["title"];
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "协办单位：", -1);
});
var _hoisted_14 = ["title"];
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "技术支持：", -1);
});
var _hoisted_16 = {
  class: "activity-info-box"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title title-location"
  }, "活动地点", -1);
});
var _hoisted_18 = {
  class: "desc"
};
var _hoisted_19 = {
  key: 0,
  class: "title title-time"
};
var _hoisted_20 = {
  key: 1,
  class: "desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_tag = _resolveComponent("a-tag");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "hover-image hover-image-absolute",
    style: _normalizeStyle("background-image:url(".concat(_ctx.current.listBanner, ")"))
  }, null, 4), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.current.status), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.current.name), 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_a_tag, {
    color: "orange"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.current.contestItem), 1)];
    }),
    _: 1
  }), _createVNode(_component_a_tag, {
    color: "blue"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.current.contestForm), 1)];
    }),
    _: 1
  })]), _ctx.current.holdItemName ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "sub-unit",
    title: _ctx.current.holdItemName
  }, [_hoisted_9, _createElementVNode("span", null, _toDisplayString(_ctx.current.holdItemName), 1)], 8, _hoisted_8)) : _createCommentVNode("", true), _ctx.current.undertakeItemName ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "sub-unit",
    title: _ctx.current.undertakeItemName
  }, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(_ctx.current.undertakeItemName), 1)], 8, _hoisted_10)) : _createCommentVNode("", true), _ctx.current.assistItemName ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "sub-unit",
    title: _ctx.current.assistItemName
  }, [_hoisted_13, _createElementVNode("span", null, _toDisplayString(_ctx.current.assistItemName), 1)], 8, _hoisted_12)) : _createCommentVNode("", true), _ctx.current.supportItemName ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "sub-unit",
    title: _ctx.current.supportItemName
  }, [_hoisted_15, _createElementVNode("span", null, _toDisplayString(_ctx.current.supportItemName), 1)], 8, _hoisted_14)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "check-more",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.checkDetail && _ctx.checkDetail.apply(_ctx, args);
    })
  }, "了解详情"), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.current.activityArea), 1), _ctx.current.itemName ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.current.itemName), 1)) : _createCommentVNode("", true), _ctx.current.itemValue ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.current.itemValue), 1)) : _createCommentVNode("", true)])])])]);
}